export default() => {
	//  let mobile_regExp = /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince|iPhone|iPad|iPod|Windows Phone)/i,
	//      is_mobile = navigator.userAgent.toLowerCase().match(mobile_regExp) != null;
	//  if (is_mobile) return 'phone'    
	//  else return 'pc'
	let width = document.documentElement.clientWidth;
	if(width > 560) {
		return 'pc'
	} else {
		return 'phone'
	}
}